
const initialState = { etiquetas: [], cereal: null, cerealVariedad: null }

export function reducerDropdownParaFiltroReporteParaEmbarque (state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_ETIQUETAS_DROPDOWN_PARA_FILTRO_PARA_EMBARQUE':
      return { ...state, etiquetas: action.etiquetas }
    case 'UPDATE_CEREAL_DROPDOWN_ETIQUETA_PARA_FILTRO_PARA_EMBARQUE':
      return { ...state, cereal: action.cereal }
    case 'UPDATE_CEREAL_VARIEDAD_DROPDOWN_ETIQUETA_PARA_FILTRO_PARA_EMBARQUE':
      return { ...state, cerealVariedad: action.cerealVariedad }
    default:
      return state
  }
}
